import React from 'react';
import ReactDOM from 'react-dom';
import Relay from 'react-relay';
import PropTypes from 'prop-types';

import classNames from 'classnames';
import { trackEvent } from 'dibs-tracking';
import mobileCheck from 'bunsen/helpers/mobileCheck';
import forceFavorite from '../../../favorites/forceFavorite.es';
import { SAVE_ITEM_FLOW } from 'dibs-auth-modal/dist/constants';
import userHelper from '../../../global/core/commonjs/userHelper';
import { CALLOUT_TYPE_SAVE_ITEM } from '../../../components/Callout/calloutHelper.es';

import HeartComponent from 'dibs-portfolio-heart';
import Callout from '../../../components/Callout/Callout';

import styles from './PdpFavoriteItem-style.scss';
import { copy as calloutCopy } from './PdpFavoriteItemCallout.json';

function getRelayVariables({ userId, itemId }) {
    return {
        userId,
        itemId,
        userIds: [userId],
        hasUserId: !!userId,
        selectedItemIds: [itemId]
    };
}

class PdpFavoriteItem extends React.Component {
    constructor(props) {
        super(props);

        this.alreadyForced = false;
        this.authModalShow = this.authModalShow.bind(this);
        this.onFavorited = this.onFavorited.bind(this);
        this.onUnFavorited = this.onUnFavorited.bind(this);
    }

    componentDidMount() {
        if (this.props.viewer) {
            this.forceFavorite();
            this.alreadyForced = true;
        }
    }

    componentDidUpdate() {
        if (!this.alreadyForced && this.props.viewer) {
            this.forceFavorite();
            this.alreadyForced = true;
        }
    }

    authModalShow(favoriteItem) {
        userHelper.checkLogin({
            label: 'save item - product page'
        }, SAVE_ITEM_FLOW).then(favoriteItem);
    }
    onFavorited() {
        this.trackFavoriting("item added");
    }

    onUnFavorited() {
        this.trackFavoriting("item removed");
    }

    trackFavoriting(action) {
        trackEvent({
            action,
            label: "PDP",
            category: "item favoriting"
        });
    }

    forceFavorite() {
        const el = ReactDOM.findDOMNode(this);
        const { portfolioItemMatches } = this.props.viewer;

        forceFavorite.init({
            type: forceFavorite.TYPE_ITEM,
            isFavorited: !!portfolioItemMatches && !!portfolioItemMatches.length,
            heartEl: el.getElementsByClassName('js-heart-component')[0]
        });
    }

    render() {
        const { showCircle, viewer, callout, ...params } = this.props;
        const className = classNames(styles.pdpHeartItem, {
            [styles.withCircle]: showCircle
        });

        return (
            <div className={className}>
                <div className={styles.heartComponentWrapper} data-tn="item-save-to-portfolio">
                    <HeartComponent
                        className="js-heart-component"

                        viewer={viewer}
                        {...getRelayVariables(params)}

                        // handlers
                        authModalShow={this.authModalShow}
                        onFavorited={this.onFavorited}
                        onUnFavorited={this.onUnFavorited}
                    />
                </div>

                {/* SaveItem callout */}
                { !mobileCheck.any() && !showCircle ?
                    <Callout
                        callout={callout}
                        copy={calloutCopy}
                        type={CALLOUT_TYPE_SAVE_ITEM}
                    />
                : null }
            </div>
        );
    }
}

PdpFavoriteItem.propTypes = {
    showCircle: PropTypes.bool,
    userId: PropTypes.string,
    itemId: PropTypes.string,
    viewer: PropTypes.object,
    callout: PropTypes.object
};

export default Relay.createContainer(
    PdpFavoriteItem, {
        initialVariables: {
            itemId: null,
            userId: null,
            userIds: [],
            hasUserId: false,
            selectedItemIds: []
        },
        prepareVariables: params => getRelayVariables(params),
        fragments: {
            viewer: ({ userId, selectedItemIds }) => Relay.QL`
                fragment on Viewer {
                    ${HeartComponent.getFragment('viewer', { userId, selectedItemIds })}
                    portfolioItemMatches(userIds: $userIds, itemIds: $selectedItemIds, portfolioTypes: [HEART]) @include(if: $hasUserId) {
                        portfolioId
                    }
                }
            `
        }
    }
);



// WEBPACK FOOTER //
// ./assets/js/newPdp/components/Favorites/PdpFavoriteItem.jsx